import { render } from "./DeleteVendorServiceModal.vue?vue&type=template&id=748763e7"
import script from "./DeleteVendorServiceModal.vue?vue&type=script&lang=js"
export * from "./DeleteVendorServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__